<script setup lang="ts">
import {HeartIcon} from "lucide-vue-next";
import {computed, type HTMLAttributes, type Ref, ref } from "vue";
import type {ProductResponse} from "../../../responses/ProductResponse";
import {useFavoriteStore} from "../../stores/favorite";
import NoAccountModal from "./NoAccountModal.vue";

interface Props {
    product: ProductResponse
    iconClass?: HTMLAttributes['class']
}
const props = defineProps<Props>();

const favoriteStore = useFavoriteStore();
const loggedIn: Ref<boolean> = ref(window.logged_in ?? false);
const isFavorite: Ref<boolean> = ref(props.product.is_favorite);
const noAccountModal: Ref<boolean> = ref(false);

const toggleFavorite = () => {
    if (!loggedIn.value) {
        noAccountModal.value = true;
        return;
    }
    favoriteStore.toggleFavorite(props.product.id).then(() => {
        isFavorite.value = !isFavorite.value;
    }).catch(console.error);
}

const buttonClass = computed(() =>
    isFavorite.value
        ? ' text-red-600'
        : 'text-secondary-400'
);
</script>

<template>
    <button
        :class="[iconClass, buttonClass]"
        type="button"
        @click.prevent="toggleFavorite"
        class="inline-flex h-14 w-14 items-center justify-center rounded-full bg-white border border-secondary-200/50 transition hover:text-red-600"
        aria-label="favorite"
    >
        <HeartIcon class="h-5 w-5" :fill="isFavorite ? 'currentColor' : 'none'" />
    </button>

    <NoAccountModal v-if="noAccountModal" @close="noAccountModal = false"></NoAccountModal>
</template>
